import {
  trackSelectFinancialInstitutionIndia,
  trackSelectSourceOfFundsIndia,
} from 'actions/tracker/sourceOfFunds';
import {
  OFFER_SOURCE_OF_FUNDS_INDIA,
  SELECTED_FINANCIAL_INSTITUTION,
} from 'constants/fields';
import { CLEAR_FIELDS } from 'constants/ui';
import type { PayexThunkAction } from 'store/configureStore';
import {
  getOfferFieldIdsToClear,
  resetSelectedOffer,
  setFieldValue,
} from '../ui';

export const clearOfferFieldsForIndia =
  (): PayexThunkAction => (dispatch, getState) => {
    const state = getState();
    const ids = getOfferFieldIdsToClear(state);

    const idsWithoutSourceOfFunds = ids.filter(
      id => id !== OFFER_SOURCE_OF_FUNDS_INDIA,
    );

    dispatch({
      type: CLEAR_FIELDS,
      payload: idsWithoutSourceOfFunds,
    });
  };

export const setSourceOfFunds =
  (sourceOfFunds: string): PayexThunkAction =>
  dispatch => {
    dispatch(setFieldValue(OFFER_SOURCE_OF_FUNDS_INDIA, sourceOfFunds));
    dispatch(setFieldValue(SELECTED_FINANCIAL_INSTITUTION, ''));
    dispatch(resetSelectedOffer());
    dispatch(trackSelectSourceOfFundsIndia(sourceOfFunds));
  };

export const setFinancialInstitution =
  (financialInstitution: string): PayexThunkAction =>
  dispatch => {
    dispatch(
      setFieldValue(SELECTED_FINANCIAL_INSTITUTION, financialInstitution),
    );
    dispatch(trackSelectFinancialInstitutionIndia(financialInstitution));
    dispatch(resetSelectedOffer());
  };
